module.exports = __webpack_public_path__ + "img/banner01.0ec9f156.jpg";